import singleAdapter from '../event/adapter';

const adapter = {
  responseBodyToRender(input = []){
    let output = []

    if(input && input.length > 0){
      for (let index = 0; index < input.length; index++) {
        const element = input[index];
        output.push(singleAdapter.responseBodyToRender(element))
      }
    }

    return output
  },
  responseBodyToOptions(input){
    let output = [];

    if(input && input.length > 0){
      for (let index = 0; index < input.length; index++) {
        const element = input[index];
        output.push({
          label: element.judulActivity[0],
          value: element.eventId
        })
      }
    }

    return output
  },
}

export default adapter
